(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('IntegrationsSettingsController', IntegrationsSettingsController);

    function IntegrationsSettingsController($scope, $translate, $timeout, $filter, OruloService, toastr, ModalFactory, moment, ORULO_INTEGRATION_STATUS) {
        var vm = this;

        vm.$onInit = init;

        vm.orulo = {
            secret: null,
            clientId: null,
            status: null,
            states: [],
        };

        vm.isLoading = false;
        vm.isDisconnected = false;
        vm.isErrorSave = false;
        vm.isErrorToken = false;
        vm.error = null;
        vm.checkedOptions = null;
        const DATE_FORMAT = $translate.instant('momentDateTime24HFormat');

        vm.isPropertySelected = function(property) {
            return vm.orulo && vm.orulo.states && vm.orulo.states.includes(property);
        };

        vm.dropdownOptions = [
            {
                label: "Acre",
                property: "AC",
                checked: vm.isPropertySelected("AC"),
            },
            {
                label: "Alagoas",
                property: "AL",
                checked: vm.isPropertySelected("AL"),
            },
            {
                label: "Amapá",
                property: "AP",
                checked: vm.isPropertySelected("AP"),
            },
            {
                label: "Amazonas",
                property: "AM",
                checked: vm.isPropertySelected("AM"),
            },
            {
                label: "Bahia",
                property: "BA",
                checked: vm.isPropertySelected("BA"),
            },
            {
                label: "Ceará",
                property: "CE",
                checked: vm.isPropertySelected("CE"),
            },
            {
                label: "Distrito Federal",
                property: "DF",
                checked: vm.isPropertySelected("DF"),
            },
            {
                label: "Espírito Santo",
                property: "ES",
                checked: vm.isPropertySelected("ES"),
            },
            {
                label: "Goiás",
                property: "GO",
                checked: vm.isPropertySelected("GO"),
            },
            {
                label: "Maranhão",
                property: "MA",
                checked: vm.isPropertySelected("MA"),
            },
            {
                label: "Mato Grosso",
                property: "MT",
                checked: vm.isPropertySelected("MT"),
            },
            {
                label: "Mato Grosso do Sul",
                property: "MS",
                checked: vm.isPropertySelected("MS"),
            },
            {
                label: "Minas Gerais",
                property: "MG",
                checked: vm.isPropertySelected("MG"),
            },
            {
                label: "Pará",
                property: "PA",
                checked: vm.isPropertySelected("PA"),
            },
            {
                label: "Paraíba",
                property: "PB",
                checked: vm.isPropertySelected("PB"),
            },
            {
                label: "Paraná",
                property: "PR",
                checked: vm.isPropertySelected("PR"),
            },
            {
                label: "Pernambuco",
                property: "PE",
                checked: vm.isPropertySelected("PE"),
            },
            {
                label: "Piauí",
                property: "PI",
                checked: vm.isPropertySelected("PI"),
            },
            {
                label: "Rio de Janeiro",
                property: "RJ",
                checked: vm.isPropertySelected("RJ"),
            },
            {
                label: "Rio Grande do Norte",
                property: "RN",
                checked: vm.isPropertySelected("RN"),
            },
            {
                label: "Rio Grande do Sul",
                property: "RS",
                checked: vm.isPropertySelected("RS"),
            },
            {
                label: "Rondônia",
                property: "RO",
                checked: vm.isPropertySelected("RO"),
            },
            {
                label: "Roraima",
                property: "RR",
                checked: vm.isPropertySelected("RR"),
            },
            {
                label: "Santa Catarina",
                property: "SC",
                checked: vm.isPropertySelected("SC"),
            },
            {
                label: "São Paulo",
                property: "SP",
                checked: vm.isPropertySelected("SP"),
            },
            {
                label: "Sergipe",
                property: "SE",
                checked: vm.isPropertySelected("SE"),
            },
            {
                label: "Tocantins",
                property: "TO",
                checked: vm.isPropertySelected("TO"),
            },
        ];

        vm.toggleProperty = function (property) {
            if (!vm.orulo.states) {
                vm.orulo.states = [];
            }
            var index = vm.orulo.states.indexOf(property);
            if (index > -1) {
                vm.orulo.states.splice(index, 1);
            } else {
                vm.orulo.states.push(property);
            }

            vm.mapCheckedOptions();
        };

        vm.mapCheckedOptions = function() {
            vm.dropdownOptions.forEach(function(option) {
                option.checked = vm.orulo.states.includes(option.property);
            });
            vm.checkedOptions = vm.orulo.states ? vm.orulo.states.join(', ') : '';
        };

        function mapOruloResponse(response) {
            if (!response) {
                vm.orulo = {
                    secret: null,
                    clientId: null,
                    states: [],
                    status: null,
                };

                vm.dropdownOptions.forEach(function (option) {
                    option.checked = false;
                });
                vm.checkedOptions = '';

                return null;
            }

            vm.orulo = {
                clientId: response.clientId,
                secret: response.secret,
                states: response.states || [],
                integrationStartedAt: null,
                lastIntegration: response.lastIntegration ? moment(response.lastIntegration).format(DATE_FORMAT).toString() : null,
                status: response.status
            };

            vm.mapCheckedOptions();

            return vm.orulo;

        }

        function loadOruloConfiguration() {
            vm.isLoading = true;
            OruloService.getByHubId()
                .then(function (response) {
                    vm.orulo = mapOruloResponse(response);
                })
                .catch(function (error) {
                    vm.error = error;
                    if (error.status !== 404) {
                        toastr.error($translate.instant('settings.integrations-hub-immo.orulo.messages.error-fetch'));
                    }
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        vm.disconnect = function () {
            vm.isLoading = true;

            OruloService.disconnect()
                .then(function () {
                    vm.error = null;
                    vm.isDisconnected = true;
                    vm.orulo = mapOruloResponse();
                    toastr.success($translate.instant('settings.integrations-hub-immo.orulo.messages.disconnect'));
                })
                .catch(function (error) {
                    vm.error = error;
                    vm.isDisconnected = false;
                    vm.orulo.integrationStartedAt = null;
                    toastr.error($translate.instant('settings.integrations-hub-immo.orulo.messages.error'));
                })
                .finally(function () {
                    vm.isLoading = false;
                    vm.isErrorSave = false;
                    vm.isErrorToken = false;
                });
        };

        vm.openDisconnectOruloModal = function () {
            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.integrations-hub-immo.orulo.disconnect-message'),
                null,
                null,
                $translate.instant('settings.integrations-hub-immo.orulo.yes'),
                $translate.instant('settings.integrations-hub-immo.orulo.no'),
                vm.disconnect
            );
        };

        vm.openReprocessOrulo = function () {
            vm.isLoading = true;

            var config = {
                clientId: vm.orulo.clientId,
                secret: vm.orulo.secret,
                states: vm.orulo.states,
            };

            OruloService.reprocess(config)
                .then(function (response) {
                    vm.error = null;
                    vm.isErrorToken = false;
                    vm.orulo = mapOruloResponse(response);
                    toastr.success(
                        $translate.instant(
                            'settings.integrations-hub-immo.orulo.messages.reprocess'
                        )
                    );
                })
                .catch(function (error) {
                    vm.error = error;
                    vm.orulo.integrationStartedAt = null;
                    checkError(error);
                })
                .finally(function () {
                    vm.isLoading = false;
                    vm.isDisconnected = false;
                    vm.isErrorSave = false;
                });
        };

        vm.openReconnectOrulo = function () {
            vm.isLoading = true;

            var config = {
                clientId: vm.orulo.clientId,
                secret: vm.orulo.secret,
                states: vm.orulo.states
            };

            OruloService.reconnect(config)
                .then(function (response) {
                    vm.error = null;
                    vm.orulo = mapOruloResponse(response);
                    toastr.success($translate.instant('settings.integrations-hub-immo.orulo.messages.success-token-toast'));
                })
                .catch(function (error) {
                    vm.error = error;
                    vm.orulo.integrationStartedAt = null;
                    checkError(error);
                })
                .finally(function () {
                    vm.isLoading = false;
                    vm.isDisconnected = false;
                    vm.isErrorSave = false;
                    vm.isErrorToken = false;
                });
        };

        /**
         * Check map error from orulo service
         * @param error
         */
        function checkError(error) {
            if (error.data.message === ORULO_INTEGRATION_STATUS.ERROR.INVALID_TOKEN) {
                toastr.error(
                    $translate.instant(
                        'settings.integrations-hub-immo.orulo.messages.error-token-toast'
                    )
                );
            } else if (error.data.message === ORULO_INTEGRATION_STATUS.ERROR.REQUIRED_CREDENTIALS) {
                toastr.error(
                    $translate.instant(
                        'settings.integrations-hub-immo.orulo.messages.required-field'
                    )
                );
            } else if (error.data.message === ORULO_INTEGRATION_STATUS.ERROR.IN_PROGRESS_JOB) {
                toastr.error(
                    $translate.instant(
                        'settings.integrations-hub-immo.orulo.messages.error-reprocess-job-in-progress'
                    )
                );
            } else if (error.data.message === ORULO_INTEGRATION_STATUS.ERROR.RATE_LIMIT_EXCEEDED) {
                toastr.error(
                    $translate.instant(
                        'settings.integrations-hub-immo.orulo.messages.error-rate-limit-exceeded'
                    )
                );
            } else {
                toastr.error(
                    $translate.instant(
                        'settings.integrations-hub-immo.orulo.messages.error-token-toast'
                    )
                );
            }
        }

        vm.createUpdateOrulo = function () {
            vm.isLoading = true;
            var config = {
                clientId: vm.orulo.clientId,
                secret: vm.orulo.secret,
                states: vm.orulo.states,
            };
            OruloService.save(config)
                .then(function (response) {
                    vm.error = null;
                    vm.orulo = mapOruloResponse(response);
                    vm.isErrorSave = false;
                    toastr.success(
                        $translate.instant(
                            'settings.integrations-hub-immo.orulo.messages.success'
                        )
                    );
                })
                .catch(function (error) {
                    vm.error = error;
                    vm.isErrorSave = true;
                    vm.orulo.integrationStartedAt = null;
                    checkError(error);
                })
                .finally(function () {
                    vm.isLoading = false;
                    vm.isDisconnected = false;
                    vm.isErrorToken = false;
                });
        };

        function init() {
            loadOruloConfiguration();
        }
    }
})();
